import { render, staticRenderFns } from "./UnbundleIcon.vue?vue&type=template&id=217089b5&"
import script from "./UnbundleIcon.vue?vue&type=script&lang=js&"
export * from "./UnbundleIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports